<template>
    <Page>
        <Container>
            <div class="mx-auto max-w-sm">
                <TemplateResourceList :key="$route.fullPath" />
            </div>
        </Container>
    </Page>
</template>

<script>
import {defineComponent} from 'vue'
import TemplateResourceList from '@/components/Template/ResourceList.vue';

export default defineComponent({
  name: 'Index',
  components: {
    TemplateResourceList,
  },
});
</script>

<style scoped lang="scss">

</style>
